/**
 * Action Types
 */

export const Types = {
    GET_REQUEST: 'produtos/GET_REQUEST',
    CLEAR_PRODUTOS: 'produtos/CLEAR_PRODUTOS'
};

/**
 * Reducer
 */

const INITIAL_STATE = {};

export default function produtos(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.GET_REQUEST:
            return { ...action.payload };

        case Types.CLEAR_PRODUTOS:
            return { ...INITIAL_STATE };

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    searchProdutos: (payload) => ({
        type: Types.GET_REQUEST,
        payload
    }),
    clearProdutos: () => ({
        type: Types.CLEAR_PRODUTOS
    })
};
